import EmployeeIndex from "./EmployeeIndex.vue";
import EmployeeAdd from "./EmployeeAdd.vue";
import EmployeeDetail from "./EmployeeDetail.vue";
import EmployeeEdit from "./EmployeeEdit.vue";
import EmployeeUpload from "./EmployeeUpload.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List Employee",
        },
        name: "EmployeeIndex",
        component: EmployeeIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Employee",
        },
        name: "EmployeeAdd",
        component: EmployeeAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Employee",
        },
        name: "EmployeeDetail",
        component: EmployeeDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Employee",
        },
        name: "EmployeeEdit",
        component: EmployeeEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload Employee",
        },
        name: "EmployeeUpload",
        component: EmployeeUpload
    },
    
]

export default routes
  